module.exports = __webpack_public_path__ + "static/web-marketing-winners-3ef7da71e7cf0627fb6c2cdd8be83ccb.svg";